module.exports = __webpack_public_path__ + "static/media/notifications-bg-grey.51bdca0a.png";